import React from "react";
import { MenuItem } from "react-contextmenu";

export default function SmartSignage() {
  function updateSmartSignage(data, document) {
    const container = document.getElementById(data.name);
    if (!container || !data.stateImage) return;

    const svgElement =
      container.tagName?.toLowerCase() === "image"
        ? container
        : container.querySelector?.("image");
    if (!svgElement) return;

    const href = getHrefForStateImage(data.stateImage);
    svgElement.setAttribute("href", href);
    svgElement.setAttributeNS(
      "http://www.w3.org/1999/xlink",
      "xlink:href",
      href,
    );
    svgElement.setAttribute("preserveAspectRatio", "none");
  }

  function getHrefForStateImage(stateImage) {
    if (stateImage.startsWith("data:")) return stateImage;
    return `data:image/png;base64,${stateImage}`;
  }

  const SmartSignageContextMenu = (props) => {
    const { contextId, contextName, activeRights, showSettings, getData, t } =
      props;

    return (
      <div id="contextmenu" className="contextmenu">
        {/*
                Will be used later
                {activeRights.some((item) => item.includes("Display.")) && ( */}
        <>
          <MenuItem
            onClick={() =>
              showSettings({
                Data: [getData(contextId)],
                Type: "SmartSignage",
              })
            }
            className="activeitem"
          >
            {t("allgemein.einstellungen")}
          </MenuItem>
        </>
        {/* )}
         */}
        <MenuItem divider />
        <MenuItem disabled>{contextName}</MenuItem>

        {activeRights.includes("Debug.ShowIds") && (
          <>
            <MenuItem divider />
            <MenuItem disabled>ID: {contextId}</MenuItem>
          </>
        )}
      </div>
    );
  };

  return {
    updateSmartSignage,
    SmartSignageContextMenu,
  };
}
